var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"is-confirm":true},on:{"confirm":_vm.onConfirm,"cancel":_vm.onClose}},[_c('div',{staticClass:"delete-text"},[_vm._v("Are you sure you wish to delete this?")])])}
var staticRenderFns = []

export { render, staticRenderFns }